import Keycloak from "keycloak-js";

const HOSTNAME = window.location.hostname;

const keycloak = new Keycloak({
  url: `https://${HOSTNAME}/auth`,
  realm: "revbell",
  clientId: "revbell-app",
});

// Logout wipes localStorage except known user preferences, so a session key
// added later is dropped by default. The legacy Symfony frontend shares this
// origin: its keys are listed here too, any unlisted one is lost on logout.
const PRESERVED_STORAGE_KEYS = [
  "mui-mode",
  "demoMode",
  "selectedCustomer",
  "wash",
  "kpis",
  "resas",
  "dateCom",
  "reference",
  "calculatrice",
  "activitiesUsers",
  "filter-lead-time",
  "etatVentesCheckedLines",
  "modalListHebergements",
  "dashboardHebergements",
  "evenementsHebergements",
  "revenueIntegrityHebergements",
  "revenueIntegrityErrors",
  "displayDailyNumber",
  "displayBudgetLanding",
  "vueSalesState",
  "vuePickUp",
  "vuePickUpState",
  "vueGraphResas",
  "vueGraphOccupation",
];

// `revbell_`: React preferences (dashboard, cockpit V2). `cockpit`: legacy
// cockpit filter lists (cockpitHebergements, cockpitZonegeo1s, ...).
const PRESERVED_STORAGE_PREFIXES = ["revbell_", "cockpit"];

const isPreservedStorageKey = (key: string) =>
  PRESERVED_STORAGE_KEYS.includes(key) ||
  PRESERVED_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix));

const clearSessionStorage = () => {
  Object.keys(localStorage)
    .filter((key) => !isPreservedStorageKey(key))
    .forEach((key) => localStorage.removeItem(key));
};

const logoutUser = async () => {
  try {
    await fetch("/logout", { method: "GET", credentials: "include" });
  } catch (e) {
    console.warn("Backend logout failed or not available");
  }

  clearSessionStorage();

  document.cookie.split(";").forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name.trim()}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });

  keycloak.logout({ redirectUri: `${window.location.origin}/login` });
};

const handleLogout = (event: React.MouseEvent) => {
  event.preventDefault();
  logoutUser();
};

export { keycloak, handleLogout, logoutUser, clearSessionStorage };
